export default {"src":"/_next/static/media/race.7b2839f1.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};